module.exports = "<select class=\"form-control\" [(ngModel)]=\"selectedID\" (change)=\"onDataChanged($event.target.value)\">\r\n  <option [ngValue]=\"null\">Select</option>\r\n  <option *ngFor=\"let agency of agencies\" [ngValue]=\"agency.id\">{{agency.name}} ({{agency.status}})</option>\r\n</select>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/shared/agency-selection/agency-selection.component.html
// module id = ../../../../../src/app/shared/agency-selection/agency-selection.component.html
// module chunks = main